import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import {
    useBreakpoint,
    withBreakpoints
} from "@/utils/breakpoints/breakpoints.provider";
import { getTagZoneIdFor } from "@/utils/tagging/tag.utils";

type NonMobileFacetsProps = RequireChildrenFor<{}>;

const _NonMobileFacets = ({ children }: NonMobileFacetsProps) => {
    const { breakpoints } = useBreakpoint();
    const isMobile = !breakpoints.lg;

    if (isMobile) {
        return null;
    }

    return (
        <section
            className={cn(
                "tw:min-w-full tw:hidden tw:row-[1/4]",
                "tw:lg:block"
            )}
            {...getTagZoneIdFor("search-facets")}
        >
            {children}
        </section>
    );
};

export const NonMobileFacets = withBreakpoints(_NonMobileFacets);
